/* Модальное окно — разметка прототипа (ui.js openModal): .ov.on > .md > .mdh/.mdb/.mdf.
   Закрывается крестиком, кликом по подложке и Esc. */
import { useEffect, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

export function Modal({ title, wide, onClose, foot, children, className }: { title: string; wide?: boolean; onClose: () => void; foot?: ReactNode; children: ReactNode; className?: string }) {
  useEffect(() => {
    const k = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', k);
    return () => document.removeEventListener('keydown', k);
  }, [onClose]);
  return createPortal(
    <div
      className="ov on"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className={'md' + (wide ? ' wmd' : '') + (className ? ' ' + className : '')}>
        <div className="mdh">
          <span className="dot"></span>
          <h2>{title}</h2>
          <button className="cls" onClick={onClose}>
            ✕
          </button>
        </div>
        <div className="mdb">{children}</div>
        {foot && <div className="mdf">{foot}</div>}
      </div>
    </div>,
    document.body,
  );
}
